import React from 'react';
import { Grid, Autocomplete, TextField } from '@mui/material';

// เลือกพนักงานจาก dropdown — ใช้ทั้งผู้รับผิดชอบ (Owner) และผู้ประสานงาน (label ต่างกันแค่
// ข้อความ ที่มาของตัวเลือก (employee) เหมือนกันเป๊ะ) ตั้งใจให้ parent วางไว้เป็น child ตรงของ
// <Grid container> เดียวกับฟิลด์อื่นๆ เหมือน ClientAutocompleteField
export function OwnerAutocompleteField({
  options, value, onChange, inputValue, onInputChange, label = 'ผู้รับผิดชอบ (Owner)',
}) {
  return (
    <Grid item xs={12} sm={6}>
      <Autocomplete
        size="small"
        options={options}
        getOptionLabel={(o) => o?.name || ''}
        isOptionEqualToValue={(o, v) => (o._id || o.id) === (v._id || v.id)}
        value={value}
        onChange={(e, v) => onChange(v)}
        inputValue={inputValue}
        onInputChange={(e, v) => onInputChange(v)}
        renderInput={(params) => <TextField {...params} label={label} />}
      />
    </Grid>
  );
}

export default OwnerAutocompleteField;
